import type { HistoryItem } from './chatHistory.types';

export const OLDER_PAGE_SIZE = 10;

function buildMockHistory(): HistoryItem[] {
  const now = new Date();

  const todayAt = (h: number, m: number): Date => {
    const d = new Date(now);
    d.setHours(h, m, 0, 0);
    return d;
  };

  const yesterdayAt = (h: number, m: number): Date => {
    const d = new Date(now);
    d.setDate(d.getDate() - 1);
    d.setHours(h, m, 0, 0);
    return d;
  };

  const daysAgo = (days: number): Date => {
    const d = new Date(now);
    d.setDate(d.getDate() - days);
    d.setHours(14, 44, 0, 0);
    return d;
  };

  return [
    { id: '1',  title: 'Outlook Email Task Summary Log 2025',   date: todayAt(19, 44) },
    { id: '2',  title: 'Project Status Update Notes V2',         date: todayAt(19, 44) },
    { id: '3',  title: 'Weekly Inbox Summary Report AI 2025',    date: todayAt(19, 44) },
    { id: '4',  title: 'Outlook Email Task Summary Log 2025',    date: yesterdayAt(19, 44) },
    { id: '5',  title: 'Project Status Update Notes V2',         date: yesterdayAt(19, 44) },
    { id: '6',  title: 'Meeting Notes - Q3 Planning Session',    date: daysAgo(3) },
    { id: '7',  title: 'Budget Review Summary Report',           date: daysAgo(4) },
    { id: '8',  title: 'Team Performance Dashboard Analysis',    date: daysAgo(5) },
    { id: '9',  title: 'Sprint Retrospective Action Items',      date: daysAgo(6) },
    { id: '10', title: 'Client Onboarding Checklist Review',     date: daysAgo(7) },
    { id: '11', title: 'Weekly Stand-up Notes Summary',          date: daysAgo(8) },
    { id: '12', title: 'Product Roadmap Discussion Log',         date: daysAgo(9) },
    { id: '13', title: 'Risk Assessment Report - Oct 2025',      date: daysAgo(10) },
    { id: '14', title: 'Stakeholder Update Email Draft',         date: daysAgo(11) },
    { id: '15', title: 'Technical Architecture Review',          date: daysAgo(12) },
    { id: '16', title: 'Customer Feedback Analysis Summary',     date: daysAgo(13) },
    { id: '17', title: 'Release Notes Draft v2.4',               date: daysAgo(14) },
    { id: '18', title: 'HR Policy Update Discussion',            date: daysAgo(15) },
    { id: '19', title: 'Sales Pipeline Review Notes',            date: daysAgo(16) },
    { id: '20', title: 'Data Migration Planning Session',        date: daysAgo(17) },
    { id: '21', title: 'Security Audit Findings Summary',        date: daysAgo(18) },
    { id: '22', title: 'Project Status Update Notes V2',         date: daysAgo(20) },
    { id: '23', title: 'Outlook Email Task Summary Log 2025',    date: daysAgo(21) },
    { id: '24', title: 'Project Status Update Notes V2',         date: daysAgo(22) },
    { id: '25', title: 'Annual Goals Review & Planning',         date: daysAgo(28) },
    { id: '26', title: 'Team Building Activity Suggestions',     date: daysAgo(29) },
    { id: '27', title: 'Infrastructure Upgrade Discussion',      date: daysAgo(30) },
  ];
}

export const MOCK_HISTORY = buildMockHistory();
